import {DataFetcher, useGrpcRequest} from '@aboutyou/data-fetcher';
import {Customer_CustomerGender} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/customer.types';
import {CustomerService_GetCustomerLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/customer/service.grpc.lazy';
import {GetCustomerResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/customer/service.types';
import {
  UserGenders,
  useCustomerSession,
  useOptionalUser,
  useUserToken,
} from '@aboutyou/user';
import React, {useEffect} from 'react';

export const LoadCustomerData = () => {
  return (
    <DataFetcher
      request={useCheckoutCustomerData()}
      View={UpdateUserData}
      Error={null}
    />
  );
};

const UpdateUserData = ({customer}: GetCustomerResponse) => {
  const {updateCache} = useOptionalUser();

  // eslint-disable-next-line local-rules/too-complex-useeffects
  useEffect(() => {
    // eslint-disable-next-line local-rules/set-state-in-use-effect
    updateCache({
      userData: {
        ...customer,
        birthday: customer.birthday
          ? new Date(customer.birthday).toISOString()
          : undefined,
        emailHash: {emh: customer.emailHash, emhec: customer.email},
        isExistingCustomer: !customer.isNewCustomer,
        loginType: customer.authenticationMethod.type,
        gender:
          customer.customerGender === Customer_CustomerGender.MALE
            ? UserGenders.Male
            : UserGenders.Female,
      },
    });
  }, [customer]);
  return null;
};

const useCheckoutCustomerData = () => {
  const userToken = useUserToken();

  const customerSession = useCustomerSession();

  const request = useGrpcRequest(
    CustomerService_GetCustomerLazy,
    {
      customerSession: customerSession!,
    },
    {
      disabled: !userToken,
    },
  );

  return request;
};
